<template>
  <div class="enterprise-page">
    <div style="width: 100%">
      <v-text-field v-model="searchQuery" class="filterSearch" prepend-icon="mdi-magnify" label="Rechercher" clearable />
    </div>
    <EnterpriseTable v-if="list.length" :data="filteredList" :text="text" @add="addItem($event)" @edit="changeItemById($event)" @remove="removeItem($event)" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { ROUTES_NAME } from '@/common/constants';
import EnterpriseTable from '@/components/common/tables/EnterpriseTable';

import { formatValues } from '../../mixins/formatValues.mixin';

export default {
  name: ROUTES_NAME.enterprise,
  components: {
    EnterpriseTable
  },
  mixins: [formatValues],
  data() {
    return {
      searchQuery: null,
      text: {
        table: 'enterprise',
        add: {
          title: "Ajout d'entreprise"
        },
        edit: {
          title: 'Modification'
        },
        remove: {
          title: 'Suppression',
          subTitle: 'Êtes-vous sûr de vouloir supprimer cette entreprise ?'
        }
      }
    };
  },
  computed: {
    ...mapGetters('enterprise', ['list']),
    filteredList() {
      if (this.list?.length > 0) {
        if (this.searchQuery) {
          const search = this.stripForSearch(this.searchQuery);
          return this.list.filter(
            enterprise => this.stripForSearch(enterprise.name)?.includes(search) || this.stripForSearch(enterprise.Profession?.label)?.includes(search)
          );
        }
        return this.list;
      }
      return [];
    }
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    ...mapActions('enterprise', ['fetchList', 'removeItem', 'addItem', 'changeItemById'])
  }
};
</script>

<style lang="scss">
.enterprise-page {
  padding: 0 10px;
}
</style>
